import { render, staticRenderFns } from "./GestionProveedores.vue?vue&type=template&id=2f5ca2c9&"
import script from "./GestionProveedores.vue?vue&type=script&lang=js&"
export * from "./GestionProveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports